import type { BinEntry, Tipo } from '../types/colheita';
import excelApi from '../api/excelApiClient';

export class ColheitaBinsApi {
  static async getAll(): Promise<BinEntry[]> {
    const response = await excelApi.get('/colheitaBins');
    return response.data;
  }

  static async createBulk(entries: BinEntry[]): Promise<BinEntry[]> {
    const response = await excelApi.post('/colheitaBins/bulk', entries);
    return response.data;
  }

  static async getTipos(): Promise<Tipo[]> {
    const response = await excelApi.get('/tipos');
    return response.data;
  }
}
